export default function TerminalTextLine({line}:{line:string}) {
  if(line === "Welcome to Sahindu Gayanuka’s workspace.") return <span className="terminal-welcome-line">Welcome to <strong>Sahindu Gayanuka</strong>’s workspace.</span>;
  const location = line.match(/^(\s{2}(?:Projects|Profile|Notebook)\s+)(~\/\S+)$/);
  if(location) return <>{location[1]}<span className="terminal-path-accent">{location[2]}</span></>;
  if(line === "Run ls to explore your home directory.") return <>Run <span className="terminal-command-accent">ls</span> to explore your home directory.</>;
  if(line === "Authenticated to sahiya.lk as guest.") return <span className="terminal-session-auth">{line}</span>;
  return <>{line || "\u00a0"}</>;
}
